import React, { PropTypes, Component } from 'react';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DATE_FORMAT } from '../../configurations';
import Controls from '../../util/controls';
import * as Actions from '../actions/bookingActions';
import { BOOKING_STATUSES, INTERNAL_STATUSES } from '../constants/bookingConstants';
import BookingWizard from '../components/bookingWizard';
import BookingStatus from '../components/bookingStatus';
import AddressUpdateConfirmation from '../components/addressUpdateConfirmation';
import { ADDRESS_UPDATE_FEATURE } from '../../core/constants/coreConstants';
import _ from 'underscore';

const propTypes = {
  actions: PropTypes.object.isRequired,
};

class BookingPage extends Component {
  constructor(props) {
    super(props);
    this.onConfirmBooking = this.onConfirmBooking.bind(this);
    this.onBookingDataSelection = this.onBookingDataSelection.bind(this);
    this.contactUs = this.contactUs.bind(this);
    
    this.state = { jobId: '', date: '', timeslot: '' };
  }

  componentDidMount() {
    let { jobId } = this.props.routeParams;

    this.props.actions.getBookingDetails(jobId);
    this.props.actions.getBookingAvailableDays(jobId);
    this.props.actions.getJobInfo(jobId);
  }

  onConfirmBooking() {
    event && event.preventDefault();

    const isrefpfsDepot = this.props.booking.details.isrefpfsDepot;

    let { jobId } = this.props.routeParams;
    let notes = _.toArray(_.filter(this.state, (state, key) => key.includes("notes"))).join("\n\n");

    let bookingData = {
      date: isrefpfsDepot ? new Date() : this.state.date.format(DATE_FORMAT),
      timeslot: isrefpfsDepot ? "-1" : this.state.timeslot,
      jobId: jobId,
      notes: notes
    };

    this.props.actions.confirmBooking(jobId, bookingData);
  }

  onBookingDataSelection(key, value) {
    this.setState({
      [key]: value
    });
  }

  contactUs() {
    setTimeout(() => browserHistory.push(`/contactUs/incorrectdetails/${this.props.routeParams.jobId}`), 0);
  }

  render() {
    const { state } = this.props.routeParams;
    const { featuresLoaded, features, booking: { apiCallInProgress, details } } = this.props;
    const isLoading = apiCallInProgress || !featuresLoaded;

    let status = {};
    let mode = "loading";
    
    if (!isLoading) {
      if (details && details.status) {
        status = {
          pending: details.status === BOOKING_STATUSES.PENDING || state === INTERNAL_STATUSES.REBOOK,
          booked: details.status === BOOKING_STATUSES.BOOKED,
          inTransit: details.status === BOOKING_STATUSES.IN_TRANSIT,
          completed: details.status === BOOKING_STATUSES.COMPLETE,
          updateAddress: state === INTERNAL_STATUSES.UPDATE_ADDRESS
        };
        
        if (status.updateAddress)
          mode = state;
        else if (status.pending)
          mode = "newBooking";
        else if (status.booked || status.inTransit || status.completed)
          mode = "confirmed";
        else
          this.contactUs();
      }
      else if (state)
        this.contactUs();
    }
    else {
      return (
        <Controls.LoadingPanel />
      );
    }

    return (
      <div className="Booking">
        {mode === "confirmed" && <BookingStatus onSubmit={this.onConfirmClose} status={status} {...this.props} />}
        {mode === "newBooking" && (
          <BookingWizard 
            onConfirmBooking={this.onConfirmBooking} 
            onBookingDataSelection={this.onBookingDataSelection} 
            currentSelections={this.state} 
            allowAddressUpdate={features[ADDRESS_UPDATE_FEATURE]} 
            {...this.props} />
        )}
        {mode === "updateAddress" && <AddressUpdateConfirmation  {...this.props} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    booking: state.booking,
    uiState: state.core.uiState,
    features: state.core.features,
    featuresLoaded: state.core.featuresLoaded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

BookingPage.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(BookingPage);



// WEBPACK FOOTER //
// ./app/booking/containers/bookingPage.js